import Model, { belongsTo } from '@ember-data/model';

export default class WieConfigEditorDefaults extends Model {
  @belongsTo('wie-config/normal', { inverse: null, async: false, embedded: true }) normal;
  @belongsTo('wie-config/text', { inverse: null, async: false, embedded: true }) text;
  @belongsTo('wie-config/lines', { inverse: null, async: false, embedded: true }) lines;
  @belongsTo('wie-config/shape', { inverse: null, async: false, embedded: true }) shape;
  @belongsTo('wie-config/image', { inverse: null, async: false, embedded: true }) image;
  @belongsTo('wie-config/icons', { inverse: null, async: false, embedded: true }) icons;

  get isDirty() {
    return super.isDirty ||
      this.normal.isDirty ||
      this.text.isDirty ||
      this.lines.isDirty ||
      this.shape.isDirty ||
      this.image.isDirty ||
      this.icons.isDirty;
  }
}
